import React, {useCallback, useContext, useEffect, useState} from 'react'
import {AuthContext} from "../context/AuthContext"
import config from "../config.json"
import {useHttp} from "../hooks/http.hook"
import {useNavigate, useParams} from "react-router-dom"
import {NoteViewCardClass} from "../components/NoteViewCardClass"
import {
    getAuthHeader, getLocalStorageItem,
    getPathAndQueryParams,
    getPathBack,
    objectLang,
    removeCookieOfFolderId,
    setErrorWindow, setLocalStorageItem,
    setPathBack
} from "../functions"
import {ModalWin} from "../elements/ModalWin"
import {LoaderClass} from "../elements/LoaderClass"
import {ViewWindowQuestion} from "../elements/ViewWindowQuestion"

export const NotePage = ({noteObject = null}) => {
    setLocalStorageItem('page', 'NotePage')
    const auth = useContext(AuthContext)
    const {request, loading} = useHttp()
    const [note, setNote] = useState({})
    const [newNote, setNewNote] = useState({})
    const [allowed, setAllowed] = useState(true)
    const [dataModal, setDataModal] = useState({})
    const [isQuestion, setIsQuestion] = useState(true)
    const navigate = useNavigate()
    const noteId = useParams().id
    const lang = objectLang().language
    const l = lang.lang

    const getNote = useCallback(async () => {
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/note/view/${noteId}`,
                'GET',
                null,
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.code === 542 && data.accessLink) {
                window.location.replace(data.accessLink)
            }

            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                setNote(data.note)
                setLocalStorageItem('note-DB', data.note)
            }

        } catch (e) {
            navigate(`/${l}/`, {replace: true})
            // window.location.replace(`/${l}/`)
        }
    }, [auth, request, noteId, l, navigate])

    useEffect(() => {
        if (!noteObject) {
            getNote().then()
        } else {
            const newNote = getLocalStorageItem('note-new')
            setNote(newNote)
        }
        setPathBack()
    }, [getNote, noteObject, auth, noteId])

    if (auth.isAuthenticated) {
        setPathBack(`/${l}/folder/open/${note.parentFolder}`)
    }
    if (note.owner === '64648579d6767031d41bd359') {
        setPathBack(`/${l}/folder/open-public/${note.parentFolder}`)
    }

    const saveNoteHandler = async () => {
        const l = lang.lang
        let host
        window.location.host === 'localhost:3000' ? host = config.localHost : host = config.onrender
        try {
            const data = await request(
                `${host}/api/note/save/${note["_id"]}`,
                'POST',
                {
                    userId: auth.userId,
                    name: document.querySelector('#name').value,
                    body: document.querySelector('#body-note').value,
                    parentFolder: note.parentFolder
                },
                {
                    Authorization: getAuthHeader(auth)
                })

            if (data.status > 200) {
                setAllowed(false)
                setDataModal(setErrorWindow('', data.code))
            } else {
                removeCookieOfFolderId(note.parentFolder)
                window.location.replace(getPathAndQueryParams())
            }

        } catch (e) {
            window.location.replace(`/${l}/`)
        }
    }

    const closeNoteHandler = (oldNote, updatedNote) => {
        setNewNote(updatedNote)
        if ((oldNote.body !== updatedNote.body) || ((oldNote.name !== updatedNote.name))) {
            setLocalStorageItem('note-new', updatedNote)
            setIsQuestion(false)
            setDataModal(
                setErrorWindow(
                    lang.body.notePage.windowRequestIfSave.titleUpdate,
                    '',
                    lang.body.notePage.windowRequestIfSave.descriptionUpdate,
                    lang.body.notePage.windowRequestIfSave.btnOKUpdate,
                    'saveNote',
                    lang.body.notePage.windowRequestIfSave.btnCancelUpdate,
                    'replaceToBack',
                    'success',
                    'danger'))
        } else {
            navigate(getPathBack(), {replace: true})
            // window.location.replace(getPathBack())
        }
    }

    if (loading) {
        return <LoaderClass/>
    }

    if (!allowed) {
        return (
            <>
                <ModalWin data={dataModal}/>
            </>
        )
    }

    if (!isQuestion) {
        return (
            <>
                {<NotePage noteObject={getLocalStorageItem('note-new')}/>}
                {<ViewWindowQuestion object={newNote} data={dataModal}/>}
            </>
        )
    }

    return (
        <>
            {<NoteViewCardClass
                auth={auth}
                note={note}
                saveNoteHandler={saveNoteHandler}
                closeNoteHandler={closeNoteHandler}
                navigate={navigate}
            />}
        </>
    )
}

export class saveHandler {
}